import * as _isEqual from 'lodash/isEqual';

export function isEqual(value, other) {
    return _isEqual(value, other);
}
